<script setup lang="ts">
import { useToastStore } from "@/stores/toastStore";
import CDTToast from "@/components/custom/CDTToast.vue";

const toastStore = useToastStore();
console.log('toastStore : ', toastStore.toasts)
</script>
<template>
  <div>
    <CDTToast
        v-for="toast in toastStore.toasts"
        :key="toast.id"
        :id="toast.id"
        :title="toast.title"
        :content="toast.content"
    />
  </div>
</template>


